import {API_URL, apiDelete} from '../api'
import {ApiRes} from '../../types/api'
import {IAnnouncement} from './getAnnounceList'

interface IProp {
    success?: true
}

export const postDeleteAnnounce = async (id?: string): Promise<ApiRes<IProp>> => {
    return await apiDelete(API_URL, `official/post/${id}`)
}
